import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Controller, useForm } from 'react-hook-form'
import { loginFormScheme } from '../../../util/validationSchema'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { userLogin } from '../../../redux/slices/authSlice'
import { PROJECT_TITLE } from '../../../util/constant'
import { MainLogo } from '../../../helper/imagepath'
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast } from '../../../util/Toast/toast'
import { getLocal } from '../../../helper/storage'

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const device_token = getLocal('device_token')

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(loginFormScheme)
  })

  const [eye, seteye] = useState(true)

  const submitLoginForm = (data) => {
    if (data) {
      changeLoader(true)
      dispatch(userLogin({ ...data, device_token: device_token })).then(({ payload, error }) => {
        if (payload?.status === 200) {
          navigate('/')
          changeLoader(false)
        } else {
          errorToast(payload?.data?.status_message || error?.message || 'something went wrong.')
          changeLoader(false)
        }
      })
    }
  }

  const onEyeClick = () => seteye(!eye)

  return (
    <>
      <Helmet>
        <title>{PROJECT_TITLE}</title>
      </Helmet>
      <div className="auth-wrapper-main">
        <div className="auth-container">
          <div className="text-center">
            <img
              className="img-fluid auth_logo"
              src={MainLogo}
              onError={(event) => {
                event.target.src = MainLogo
              }}
              alt="Logo"
            />
          </div>
          <div className="authbox">
            <div className="auth-left">
              <div className="auth-page-title">Login</div>

              <div className="auth-form-content">
                <form onSubmit={handleSubmit(submitLoginForm)}>
                  <div className="form-group input_text">
                    <label className="form-control-label">Email</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                          type="text"
                          value={value || ''}
                          onChange={onChange}
                          autoComplete="false"
                          // ref={emailRem}
                        />
                      )}
                    />

                    <small>{errors?.email?.message}</small>
                  </div>
                  <div className="form-group input_text mb-2">
                    <label className="form-control-label">Password</label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <div className="pass-group">
                          <input
                            type={eye ? 'password' : 'text'}
                            className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                            style={{
                              paddingRight: '36px'
                            }}
                            value={value || ''}
                            onChange={onChange}
                            autoComplete="false"
                            // ref={passwordRem}
                          />
                          <span onClick={onEyeClick} className={`fa toggle-password ${eye ? 'fa-eye-slash' : 'fa-eye'}`} />
                        </div>
                      )}
                    />

                    <small>{errors?.password?.message}</small>
                  </div>

                  <div className="row">
                    <div className="col-12 text-end">
                      <Link className="forgot-link" to="/forgot-password">
                        {' '}
                        Forgot Password ?{' '}
                      </Link>
                    </div>
                  </div>

                  <div className="auth-btn-div">
                    <button className="btn" type="submit">
                      Login
                    </button>
                  </div>
                </form>

                {/* <div className={`${styles.divider_div}`}>
                  <img src={dividerline} width={155} height={1} alt="logo" />
                  <p className="common_para text-center mx-3">Or Getting started is easy</p>
                  <img src={dividerline} width={155} height={1} alt="logo" />
                </div> */}
              </div>
            </div>

            <div className="auth-right auth-login-bg-img"></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login
